import { render, staticRenderFns } from "./SuccessProcedure.vue?vue&type=template&id=e9ccb69a&"
import script from "./SuccessProcedure.vue?vue&type=script&lang=js&"
export * from "./SuccessProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports